import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  CreateMemberRequest,
  DeleteMemberRequest,
  DownloadMemberExcelRequest,
  DownloadMemberExcelResponse,
  UpdateMemberRequest,
  ViewAllMembersRequest,
  ViewMemberProfileRequest,
  ViewMemberRequest,
  ViewTribeMembersRequest
} from './member.types';

export const requestCreateMember = createAction<SagaPayload<CreateMemberRequest>['payload']>('request/createMember');

export const requestViewAllMembers =
  createAction<SagaPayload<ViewAllMembersRequest>['payload']>('request/viewAllMembers');

export const requestUpdateMember = createAction<SagaPayload<UpdateMemberRequest>['payload']>('request/updateMember');

export const requestDeleteMember = createAction<SagaPayload<DeleteMemberRequest>['payload']>('request/deleteMember');

export const requestDownloadMemberExcel =
  createAction<SagaPayload<DownloadMemberExcelRequest, DownloadMemberExcelResponse>['payload']>(
    'request/downloadMemberExcel'
  );

export const requestViewTribeMembers =
  createAction<SagaPayload<ViewTribeMembersRequest>['payload']>('request/viewTribeMembers');

export const requestViewMember = createAction<SagaPayload<ViewMemberRequest>['payload']>('request/viewMember');

export const requestViewMemberProfile =
  createAction<SagaPayload<ViewMemberProfileRequest>['payload']>('request/viewMemberProfile');
